const selectVoterStatusOptions = [
  { id: 1, name: 'Voto conquistado', enum: 'VOTE_WON', color: 'status-ok' },
  { id: 2, name: 'Voto perdido', enum: 'LOST_VOTE', color: 'status-error' },
  { id: 3, name: 'Voto a conquistar', enum: 'VOTE_TO_WIN', color: 'status-warning' },
];

export default selectVoterStatusOptions;
